function flamBuildChain(container, count){
  if(!container) return;
  for(var i=0;i<count;i++){
    var link = document.createElement('div');
    link.className = 'flam-lock__link' + (i % 2 === 1 ? ' flam-turn' : '');
    link.style.setProperty('--i', i);
    container.appendChild(link);
  }
}

function flamPlayTone(freq, dur, type, delay){
  try{
    var ctx = window.__flamAudioCtx || (window.__flamAudioCtx = new (window.AudioContext || window.webkitAudioContext)());
    var o = ctx.createOscillator();
    var g = ctx.createGain();
    o.type = type; o.frequency.value = freq;
    o.connect(g); g.connect(ctx.destination);
    var t = ctx.currentTime + (delay || 0);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.05, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.start(t); o.stop(t + dur + 0.05);
  }catch(e){}
}
function flamChime(){ flamPlayTone(880,.12,'triangle',0); flamPlayTone(1320,.15,'triangle',.09); flamPlayTone(1760,.2,'triangle',.18); }
function flamBuzz(){ flamPlayTone(160,.18,'sawtooth',0); }

var flamCurrentCard = null;

// --- Access-code hashing -----------------------------------------------
// The access code is never sent to the page in plain text (see
// product-lock.liquid). We hash the customer's input with the same
// algorithm (SHA-256 of the uppercased code) and compare hashes.
async function flamSha256Hex(str){
  var enc = new TextEncoder().encode(str);
  var buf = await crypto.subtle.digest('SHA-256', enc);
  return Array.from(new Uint8Array(buf)).map(function(b){ return b.toString(16).padStart(2, '0'); }).join('');
}

// --- Purchase gating -----------------------------------------------------
// Restricted products must never be purchasable until unlocked: this
// disables the size selector and Add to Bag button (and flags them so we
// only re-enable what we disabled — never something Dawn itself disabled
// for a genuinely sold-out variant), and shows an inline notice in their
// place. Only applies to full-page product locks (grid-card locks have no
// purchase form next to them).
function flamGatePurchase(lockEl){
  var productInfo = lockEl.closest('product-info');
  if(!productInfo) return;

  var controls = productInfo.querySelectorAll(
    'variant-selects input, variant-selects select, variant-selects button, product-form input, product-form select, product-form button'
  );
  controls.forEach(function(el){
    if(!el.disabled){
      el.disabled = true;
      el.setAttribute('data-flam-lock-disabled', '');
    }
  });

  if(!productInfo.querySelector('.flam-lock-gate-banner')){
    var anchor = productInfo.querySelector('variant-selects') || productInfo.querySelector('product-form');
    if(anchor){
      var banner = document.createElement('p');
      banner.className = 'flam-lock-gate-banner';
      banner.innerHTML = '<span class="svg-wrapper flam-lock-gate-banner__icon" aria-hidden="true">'
        + '<svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M12 1a5 5 0 00-5 5v3H6a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2v-9a2 2 0 00-2-2h-1V6a5 5 0 00-5-5zm-3 8V6a3 3 0 016 0v3H9z"/></svg>'
        + '</span> Restricted piece — enter your access code above to unlock sizing and purchase options.';
      anchor.insertAdjacentElement('beforebegin', banner);
    }
  }
}

function flamUngatePurchase(lockEl){
  var productInfo = lockEl.closest('product-info');
  if(!productInfo) return;

  productInfo.querySelectorAll('[data-flam-lock-disabled]').forEach(function(el){
    el.disabled = false;
    el.removeAttribute('data-flam-lock-disabled');
  });

  var banner = productInfo.querySelector('.flam-lock-gate-banner');
  if(banner) banner.remove();
}

function flamOpenModal(lockEl){
  if(lockEl.classList.contains('flam-unlocked')) return;
  var modal = document.querySelector('[data-flam-modal]');
  if(!modal) return;
  flamCurrentCard = lockEl;
  var input = modal.querySelector('[data-flam-modal-input]');
  var errorMsg = modal.querySelector('[data-flam-modal-error]');
  var unlockBtn = modal.querySelector('[data-flam-modal-unlock]');
  modal.classList.add('flam-open');
  input.value = '';
  input.classList.remove('flam-err');
  errorMsg.classList.remove('flam-show');
  unlockBtn.classList.remove('flam-success');
  unlockBtn.textContent = 'Unlock';
  unlockBtn.disabled = false;
  input.disabled = false;
  setTimeout(function(){ input.focus(); }, 60);
}

function flamCloseModal(){
  var modal = document.querySelector('[data-flam-modal]');
  if(!modal) return;
  modal.classList.remove('flam-open');
  var panel = modal.querySelector('[data-flam-modal-panel]');
  if(panel) panel.classList.remove('flam-shake');
}

function flamUnlockCard(lockEl){
  lockEl.classList.add('flam-unlock-anim');
  flamUngatePurchase(lockEl);
  setTimeout(function(){
    lockEl.classList.add('flam-unlocked');
    lockEl.classList.remove('flam-unlock-anim');
  }, 2000);
}

async function flamTryUnlock(){
  if(!flamCurrentCard) return;
  var modal = document.querySelector('[data-flam-modal]');
  var panel = modal.querySelector('[data-flam-modal-panel]');
  var input = modal.querySelector('[data-flam-modal-input]');
  var errorMsg = modal.querySelector('[data-flam-modal-error]');
  var unlockBtn = modal.querySelector('[data-flam-modal-unlock]');
  var val = input.value.trim().toUpperCase();
  var expectedHash = (flamCurrentCard.dataset.accessHash || '').toLowerCase();

  unlockBtn.disabled = true;
  var valHash = await flamSha256Hex(val);
  unlockBtn.disabled = false;

  if(expectedHash && valHash === expectedHash){
    flamChime();
    unlockBtn.textContent = 'Enter collection';
    unlockBtn.classList.add('flam-success');
    input.disabled = true;
    unlockBtn.disabled = true;
    setTimeout(function(){
      flamCloseModal();
      flamUnlockCard(flamCurrentCard);
    }, 700);
  } else {
    flamBuzz();
    input.classList.remove('flam-err'); void input.offsetWidth; input.classList.add('flam-err');
    panel.classList.remove('flam-shake'); void panel.offsetWidth; panel.classList.add('flam-shake');
    errorMsg.textContent = 'Incorrect access code.';
    errorMsg.classList.add('flam-show');
    flamCurrentCard.classList.remove('flam-tremor'); void flamCurrentCard.offsetWidth; flamCurrentCard.classList.add('flam-tremor');
    setTimeout(function(){ flamCurrentCard.classList.remove('flam-tremor'); }, 500);
  }
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-flam-lock]').forEach(function(lockEl){
    flamBuildChain(lockEl.querySelector('.flam-lock__chain--a'), 7);
    flamBuildChain(lockEl.querySelector('.flam-lock__chain--b'), 7);
    lockEl.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      flamOpenModal(lockEl);
    });

    if(lockEl.classList.contains('flam-lock--full')){
      flamGatePurchase(lockEl);
    }
  });

  var modal = document.querySelector('[data-flam-modal]');
  if(modal){
    var closeBtn = modal.querySelector('[data-flam-modal-close]');
    var unlockBtn = modal.querySelector('[data-flam-modal-unlock]');
    var input = modal.querySelector('[data-flam-modal-input]');
    var panel = modal.querySelector('[data-flam-modal-panel]');
    closeBtn.addEventListener('click', function(e){ e.stopPropagation(); flamCloseModal(); });
    modal.addEventListener('click', function(e){ if(e.target === modal) flamCloseModal(); });
    panel.addEventListener('click', function(e){ e.stopPropagation(); });
    unlockBtn.addEventListener('click', function(e){ e.stopPropagation(); flamTryUnlock(); });
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter') flamTryUnlock(); });
  }
});
